<template>
  <div :id="id" class="echarts" />
</template>

<script>
export default {
  name: '',
  components: {

  },
  mixins: [

  ],
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      id: `echarts${Number(Math.random().toString().substr(3, 3) + Date.now()).toString(36)}`,
      myEchart: null
    }
  },
  computed: {

  },
  watch: {
    data: {
      handler: function() {
        this.dram()
      },
      deep: true
    }
  },
  created() {

  },
  mounted() {
    this.dram()
  },
  methods: {
    dram() {
      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        legend: {
          top: 0,
          right: 0,
          itemWidth: 15,
          itemHeight: 15,
          textStyle: {
            color: '#fff'
          }
        },
        grid: {
          top: '15%',
          left: '3%',
          right: '5%',
          bottom: '7%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.data.xData,
          axisLabel: {
            color: 'rgba(137, 157, 191, 1)',
            interval: 0
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(137, 157, 191, .3)'
            }
          }
        },
        yAxis: [
          {
            type: 'value',
            name: '',
            min: 0,
            // splitNumber: 4,
            nameTextStyle: {
              verticalAlign: 'top'
            },
            axisLabel: {
              color: 'rgba(137, 157, 191, 1)'
            },
            axisLine: {
              lineStyle: {
                color: 'rgba(137, 157, 191, .3)'
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(137, 157, 191, .3)'
              }
            }
          },
          {
            type: 'value',
            name: '',
            min: 0,
            // splitNumber: 4,
            nameTextStyle: {
              verticalAlign: 'top'
            },
            axisLabel: {
              color: 'rgba(137, 157, 191, 1)'
            },
            axisLine: {
              lineStyle: {
                color: 'rgba(137, 157, 191, .3)'
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(137, 157, 191, .3)'
              }
            }
          }
        ],
        series: [
          {
            name: '总订单数',
            type: 'bar',
            barWidth: 10,
            itemStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1,
                [{
                  offset: 0,
                  color: 'rgba(45, 212, 241, 1)'
                },
                {
                  offset: 1,
                  color: 'rgba(0, 137, 168, 1)'
                }]
              )
            },
            data: this.data.sData1
          },
          {
            name: '新激活数',
            type: 'bar',
            barWidth: 10,
            itemStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1,
                [{
                  offset: 0,
                  color: 'rgba(165, 183, 239, 1)'
                },
                {
                  offset: 1,
                  color: 'rgba(60, 76, 178, 1)'
                }]
              )
            },
            data: this.data.sData2
          }
        ]
      }
      this.myEchart = this.$echarts.init(document.getElementById(this.id))
      this.myEchart.setOption(option, true)
      window.addEventListener('resize', () => {
        this.myEchart.resize()
      })
    }
  }
}
</script>

<style scoped lang="scss">
  .echarts{
    width: 100%;
    height: 100%;
  }
</style>
